import {doHttpRequest} from "../util/NetUtil";
import {fetchApiVersion} from "./NetConstants";

export const net_uploadFile = (payload, handler, errorHandler) => {

    // have to manually set the URI for multipart
    fetch(fetchApiVersion() + "/file/upload", {
        method: 'POST',
        body: payload,
    })
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}

export const net_removeFile = (payload, handler, errorHandler) => {

    doHttpRequest("/file/remove", payload, handler, errorHandler);
}